
<template>
  <div
    class="OrderDetails"
    style="
      padding: 20px;
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    "
  >
    <div class="comeback">
      <el-button style="width:52px;" size="mini" type="primary"  @click="comeback()"><span style="font-size:12px;">返回</span></el-button>
    </div>
    <div class="RequestInfo divbox" style="margin: 3px 29px">
      <h4>委托信息</h4>
      <ul class="RI_ul">
        <li>
          <p>
            <span style="">运单号 </span><span>{{ routes.nos || "-" }}</span>
          </p>
          <p>
            <span>目的仓库</span
            ><span>
              {{ Alldata.waybilldetails.pod_country || "-" }}
            </span>
          </p>
          <p>
            <span>派送方式</span
            ><span>
              {{  setType(Alldata.waybilldetails.deliveryType || 'empty')  }}
              <template v-if="Alldata.waybilldetails.deliverySecond || (Alldata.waybilldetails.deliverySecondList && Alldata.waybilldetails.deliverySecondList.length)">
                -{{ Alldata.waybilldetails.deliverySecondList && Alldata.waybilldetails.deliverySecondList.length ?
                    Alldata.waybilldetails.deliverySecondList.join('/') : Alldata.waybilldetails.deliverySecond }}
              </template>
            </span>
          </p>
        </li>

        <li>
          <p>
            <span style="">转单号 </span
            ><span style="line-height: 15px">{{ Alldata.waybilldetails.thirdCode || "" }}  {{ Alldata.waybilldetails.thirdNos || "-" }}</span>
          </p>
          <p>
            <span>{{ transportNameMapping[Alldata.waybilldetails.transportway] || '运输' }}公司</span>
            <span>
              <template v-if="Alldata.waybilldetails.transportway === '海运'">
                {{ Alldata.waybilldetails.boatLineNameList && Alldata.waybilldetails.boatLineNameList.length ? Alldata.waybilldetails.boatLineNameList.join('/') : "-" }}
              </template>
              <template v-else-if="Alldata.waybilldetails.transportway === '空运'">
                {{ Alldata.waybilldetails.airLineNames && Alldata.waybilldetails.airLineNames.length ? Alldata.waybilldetails.airLineNames.join('/') : "-" }}
              </template>
              <template v-else-if="Alldata.waybilldetails.transportway === '陆运'">
                {{ Alldata.waybilldetails.landTransportNames && Alldata.waybilldetails.landTransportNames.length ? Alldata.waybilldetails.landTransportNames.join('/') : "-" }}
              </template>
              <template v-else>-</template>
            </span>
          </p>
          <!-- <p>
            <span>委托日期</span
            ><span>
              {{ Alldata.waybilldetails.inputtime || "-" }}
            </span>
          </p> -->
        </li>
        <li>
          <p>
            <span style="">运输方式 </span
            ><span style="line-height: 17px">{{
              Alldata.waybilldetails.transportway || "-"
            }}</span>
          </p>
          <p>
            <span>委托日期</span
            ><span>
              {{ Alldata.waybilldetails.inputtime || "-" }}
            </span>
          </p>
          <!-- <p>
            <span>入仓日期</span
            ><span>
              {{ Alldata.waybilldetails.inwarehousetime || "-" }}
            </span>
          </p> -->
        </li>
        <li>
          <p>
            <span style="">起运地</span>
            <span style="line-height: 15px">
              {{ Alldata.depwarehouse && Alldata.depwarehouse.province || "-" }}/{{
                Alldata.depwarehouse && Alldata.depwarehouse.city || "-"
              }}
            </span>
          </p>
          <p>
            <span>入仓日期</span
            ><span>
              {{ Alldata.waybilldetails.inwarehousetime || "-" }}
            </span>
          </p>
        </li>
      </ul>
    </div>
    <!-- jack start -->
    <div class="jackCard" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <!-- <img style="" src="./../../../assets/receiveIcon.png" alt="收货信息" /> -->
        <h4 style="margin-left: 4px; margin-top: -20px">收货信息</h4>
      </div>
      <div
        style="
          margin: 20px 10px 5px;
          padding: 0 10px;
          height: 40px;
          border: 1px solid #FF4D01;
          background: #fff3f4;
          border-radius: 5px;
        "
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{
            (Alldata.deswarehouse && Alldata.deswarehouse.warehouse) ||
            "暂无收货信息"
          }}
        </span>
        <span style="line-height: 40px" v-if="Alldata.deswarehouse">
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.tel) || "" }}
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.address) || "" }}
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.area) || "" }}
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.city) || "" }}
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.zipCode) || "" }}
          {{ (Alldata.deswarehouse && Alldata.deswarehouse.province) || "" }}
        </span>
      </div>
    </div>
    <!-- 请将货物送至以下仓库 -->
    <div
      v-if="!Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >请将货物送至以下仓库</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 550;
            line-height: 40px;
          "
        >
          {{ Alldata.depwarehouse && Alldata.depwarehouse.warehouse || "" }}
        </span>
        <template v-if="Alldata.depwarehouse">
          {{ Alldata.depwarehouse.tel || "" }}
          {{ Alldata.depwarehouse.province || "" }}
          {{ Alldata.depwarehouse.city || "" }}
          {{ Alldata.depwarehouse.area || "" }}
          {{ Alldata.depwarehouse.address || "" }}
        </template>
      </div>
    </div>
    <!-- 请将货物送至以下仓库end -->
    <!-- 提货信息 -->
    <div
      v-if="Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >提货信息</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 550;
            line-height: 40px;
          "
        >
          {{ Alldata.message.getgoodsname || "" }}
        </span>
        <span style="margin: 0 10px">
          {{ Alldata.message.getgoodstel || "" }}
        </span>

        {{ Alldata.message.getgoodsprovince || "" }}
        {{ Alldata.message.getgoodscity || "" }}
        {{ Alldata.message.getgoodsarea || "" }}
        {{ Alldata.message.getgoodsaddress || "" }}
      </div>
    </div>
    <!-- 提货信息end -->

    <!-- 极速下单预报FBA PRO信息 -->
    <!-- v-if="tableDataPro.length != 0" -->
    <div
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
      v-if="routes.isFastOrder == true"
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >极速下单预报FBA PRO信息</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <el-table :data="tableDataPro" border style="width: 500px !important">
          <el-table-column type="index" label="序号" width="100px">
          </el-table-column>
          <el-table-column prop="proNo" label="FBA号"> </el-table-column>
          <el-table-column prop="boxNum" label="箱数"> </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <span style="margin-right: 20px">总箱数：{{ preBoxNum }} 箱</span>
          <span style="margin-right: 20px">总重量：{{ preAllWeight }} KG</span>
          <span style="margin-right: 20px">总体积：{{ preAllCbm }} CBM</span>
        </div>
      </div>
    </div>
    <!-- 提货信息end -->

    <!-- jack end  -->
    <div class="jackCard" style="padding: 10px 30px 20px">
      <el-tabs v-model="isActiveName">
        <el-tab-pane label="商品预报信息" name="first">
          <el-table
            border
            :data="Alldata.cargobefore"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="75px"
              min-width="8%"
            ></el-table-column>
            <el-table-column prop="boxNo" label="箱号">
              <template slot-scope="scope">
                {{ scope.row.boxNo || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="poTrackingNo" label="货件追踪号">
              <template slot-scope="scope">
                {{ scope.row.poTrackingNo || "-" }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="shopName" label="商铺号">
              <template slot-scope="scope">
                {{ scope.row.shopName || "-" }}
              </template>
            </el-table-column> -->
            <el-table-column prop="goodstype" label="货物类型">
              <template slot-scope="scope">
                {{ scope.row.goodstype || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量(kgs)">
              <template slot-scope="scope">
                {{ scope.row.weight || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="长(cm)">
              <template slot-scope="scope">
                {{ scope.row.length || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="宽(cm)">
              <template slot-scope="scope">
                {{ scope.row.width || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="高(cm)">
              <template slot-scope="scope">
                {{ scope.row.height || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="cbm" label="体积(cbm)">
              <template slot-scope="scope">
                {{ scope.row.cbm || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="pcs" label="PCS数">
              <template slot-scope="scope">
                {{ scope.row.pcs || "-" }}
              </template>
            </el-table-column>
            <el-table-column min-width="100px" prop="piece" label="操作">
              <template slot-scope="scope">
                <span
                  @click="getBoxDetail(scope.row.goodsList, scope.row)"
                  style="color: #FF4D01; cursor: pointer"
                  >查看详情</span
                >
                <span
                  @click="toBoxTracking(scope.row.id)"
                  style="color: #FF4D01; cursor: pointer"
                  >查看轨迹</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="商品入仓信息" name="seccond">
          <el-table
            v-if="Alldata.cargo && Alldata.cargo.length > 0"
            border
            :data="Alldata.cargo"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="75px"
              min-width="8%"
            ></el-table-column>
            <el-table-column prop="boxNo" label="箱号">
              <template slot-scope="scope">
                {{ scope.row.boxNo || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="poTrackingNo" label="货件追踪号">
              <template slot-scope="scope">
                {{ scope.row.poTrackingNo || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="goodstype" label="货物类型">
              <template slot-scope="scope">
                {{ scope.row.goodstype || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量(kgs)">
              <template slot-scope="scope">
                {{ scope.row.weight || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="长(cm)">
              <template slot-scope="scope">
                {{ scope.row.length || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="宽(cm)">
              <template slot-scope="scope">
                {{ scope.row.width || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="高(cm)">
              <template slot-scope="scope">
                {{ scope.row.height || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="cbm" label="体积(cbm)">
              <template slot-scope="scope">
                {{ scope.row.cbm || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="pcs" label="PCS数">
              <template slot-scope="scope">
                {{ scope.row.pcs || "-" }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" prop="piece" label="操作">
              <template slot-scope="scope">
                <el-link
                  @click="getBoxDetail(scope.row.goodsList, scope.row)"
                  style="margin-right: 6px"
                  :underline="false"
                  >查看详情</el-link
                >
                <el-link
                  @click="toBoxTracking(scope.row.id)"
                  type="primary"
                  style="margin-right: 6px"
                  :underline="false"
                  >查看轨迹</el-link
                >
                <el-link
                  v-if="scope.row.pictureUrl"
                  @click="pictureUrl(scope.row)"
                  type="success"
                  :underline="false"
                  >过机图片</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <p v-else style="text-align: center; padding: 30px; font-size: 16px">
            商品暂未入仓
          </p>
        </el-tab-pane>
      </el-tabs>
      <el-button
        @click="downLoadLabel()"
        type="primary"
        size="mini"
        class="downLondBtn"
        >下载标签</el-button
      >
      <!-- <div class="tips-all">
        <span
        style="margin-left: 4px;cursor:pointer"
          @click="changeAc(1)"
          :class="{ jackTextAc: acIndex == 1, jackText: acIndex == 2 }"
          >商品预报信息</span
        >
        <span
          v-if="state == 2"
          @click="changeAc(2)"
          style="cursor: pointer;margin:0px 0px 0px 8px"
          :class="{ jackTextAc: acIndex == 2, jackText: acIndex == 1 }"
          >商品入仓信息</span
        >

      </div> -->
      <!-- <div style="margin: 20px 0" v-if="acIndex == 1"></div>
      <div style="margin: 20px 0" v-else>
        <div class="tablebox"></div>
      </div> -->
    </div>
    <div class="Information divbox" style="margin: 3px 30px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="费用信息" name="second">
          <el-table
            border
            :data="tableData1"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            ref="multipleTable"
            style="width: 77%; margin-left: 25px; border-bottom: none"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="index"
              label="序号"
              width="75px"
              min-width="8%"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label="费用项"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label="预估费用"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label="实际费用"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              min-width="8%"
            ></el-table-column>
          </el-table>
          <el-table
            border
            :data="twotableData"
            style="
              width: 77%;
              margin-left: 25px;
              border-top: none;
              margin-top: 0px;
            "
            :cell-style="{ padding: '5px 0px' }"
            :show-header="false"
          >
            <el-table-column type="index" label="" width="75px" min-width="8%">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币' &&
                    scope.row.feeitem !== '已优惠' &&
                    scope.row.feeitem !== '原价'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              min-width="8%"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="轨迹信息" name="third">
          <p
            v-if="!activitieList.length"
            style="text-align: center; padding: 30px; font-size: 16px"
          >
            暂无轨迹信息
          </p>
          <el-timeline class="jackContent" v-else>
            <el-timeline-item
              type="primary"
              v-for="(activity, index) in activitieList"
              :key="index"
              :icon="activity.icon"
              :color="index == 0 ? '' : '#999999'"
              :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime} `"
            >
              {{ activity.name }}
              {{ activity.namee }}
              <div class="descSty"><span style="color: #999999; margin-top: 6px">{{
                activity.desc ? activity.desc : "暂无"
              }}</span></div>

              <!-- <span
                style="color: #09bb07; cursor: pointer"
                v-if="activity.detailLinkType == 1"
                @click="getBoxInfo(activity.apptWarehouseOrderId)"
                >查看箱信息</span
              > -->
              <span
                style="color: #09bb07; cursor: pointer"
                v-if="activity.detailLinkType == 2"
                @click="getPics(activity.apptWarehouseOrderId)"
                >查看回执</span
              >
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <!-- <el-tab-pane label="下载标签" name="download">
          <el-button
            @click="downLoadLabel()"
            type="success"
            size="mini"
            style="margin: 10px"
            >点击下载标签</el-button
          >
        </el-tab-pane> -->
      </el-tabs>
    </div>

    <el-dialog
      center
      class="jackRadius"
      :before-close="beforeClose"
      :visible.sync="showDialog"
      :title="showPic ? '相关回执' : '箱子轨迹'"
      width="60%"
    >
      <div v-if="this.showDialog && this.showPic">
        <el-image
          v-for="(item, index) in urls"
          :key="index"
          style="
            width: 45%;
            height: 45%;
            border-radius: 20px;
            margin: 10px;
            box-shadow: 0px 0px 55px 2px rgba(6, 2, 3, 0.1);
          "
          :src="item"
          :preview-src-list="urls"
        >
        </el-image>
      </div>
      <div v-if="this.showDialog && this.showBox">
        <el-timeline class="jackContent">
          <el-timeline-item
            type="primary"
            v-for="(activity, index) in boxDatailList"
            :key="index"
            :icon="activity.icon"
            :color="index == 0 ? '' : '#999999'"
            :timestamp="`${activity.occurrenceDate} ${activity.occurrenceTime}`"
          >
            {{ activity.name }}
            {{ activity.namee }}
            <div class="descSty">
              <span style="color: #999999; margin-top: 6px">{{
              activity.desc ? activity.desc : "暂无"
            }}</span>
            </div>

          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>

    <!-- 查看箱子详情弹窗 -->
    <el-dialog
      center
      class="jackRadius"
      :visible.sync="showGoodsList"
      title="箱子详情"
      width="80%"
    >
      <div>
        <el-table
          border
          size="mini"
          :data="goodsList"
          tooltip-effect="dark"
          :header-cell-style="{ background: 'rgb(95 74 255 / 23%)' }"
          ref=""
          @selection-change="handleSelectionChange"
        >
          <!--<el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%">
          </el-table-column>-->
          <el-table-column label="中文品名">
            <template slot-scope="scope">
              {{ scope.row.namec || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="英文品名">
            <template slot-scope="scope">
              {{ scope.row.namee || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="商品类型">
            <template slot-scope="scope">
              {{ scope.row.goodstype || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              {{ scope.row.number || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="型号">
            <template slot-scope="scope">
              {{ scope.row.model || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              {{ scope.row.brand || "-" }}
            </template>
          </el-table-column>

          <el-table-column label="货值(USD)">
            <template slot-scope="scope">
              {{ scope.row.price || "-" }}
            </template>
          </el-table-column>

          <el-table-column label="海关编码">
            <template slot-scope="scope">
              {{ scope.row.hsCode || "-" }}
            </template>
          </el-table-column>

          <el-table-column label="材质">
            <template slot-scope="scope">
              {{ scope.row.materialc || "-" }}
            </template>
          </el-table-column>

          <el-table-column prop="pcs" label="用途">
            <template slot-scope="scope">
              {{ scope.row.purposec || "-" }}
            </template>
          </el-table-column>

          <el-table-column prop="pcs" label="是否带电">
            <template slot-scope="scope">
              {{
                scope.row.isHasBattery === true
                  ? "是"
                  : scope.row.isHasBattery === false
                  ? "否"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="是否带磁">
            <template slot-scope="scope">
              {{
                scope.row.isHasMagnetic === true
                  ? "是"
                  : scope.row.isHasMagnetic === false
                  ? "否"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="是否粉末/液体">
            <template slot-scope="scope">
              {{
                scope.row.isPowderLiquid === true
                  ? "是"
                  : scope.row.isPowderLiquid === false
                  ? "否"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="图片">
            <template slot-scope="scope">
              <img
                style="width: 50px; height: 50px"
                :src="scope.row.picUrl"
                alt="图片"
              />
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="销售链接">
            <template slot-scope="scope">
              <a
                v-if="scope.row.salesUrl"
                :href="scope.row.salesUrl"
                target="_blank"
              >
                {{ scope.row.salesUrl }}
              </a>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 查看图片 -->
    <el-dialog
      width="700px"
      title="测量图片"
      :visible.sync="dialogTableVisible"
    >
      <!--<img style="width:600px" :src="imgUrl" alt="">-->
      <el-image
        class="view-image"
        fit="contain"
        :src="imgUrl"
        :preview-src-list="[imgUrl]"
      >
      </el-image>
    </el-dialog>
  </div>
</template>
<script>
import qs from "qs";
export default {
  name: "OrderDetails",
  data() {
    return {
      dialogTableVisible: false,
      imgUrl: "",
      tableDataPro: [],
      itemWrap: "",
      preBoxNum: "",
      preAllWeight: "",
      state: 0,
      showGoodsList: false,
      goodsList: [],
      boxDatailList: [],
      acIndex: 1,
      boxInfo: [],
      urls: [],
      showDialog: false,
      showPic: false,
      showBox: false,
      orderNo: "FAAE202012190129A",
      activitieList: [],
      // jack
      tableData_C1: [],
      tableData_C2: [],
      tableData1: [],
      twotableData: [],
      Alldata: {
        cargobefore: [{}],
        combincostinfo: {
          amount: "",
          amountBefore: "",
          combinCostinfoList: [
            {
              amount: "",
              amountBefore: "",
              feecode: "",
              feeitem: "",
            },
          ],
          totalCost: "",
          totalCostBefore: "",
        },
        costbeforeinfo: {
          amount1: "",
          feeitemBeforeList: [
            {
              amountBefore: "",
              cnyamountBefore: "",
              cnycurrencyBefore: "",
              currencyBefore: "",
              feecode: "",
              feeitemBefore: "",
              piece: "",
              price: "",
            },
          ],
        },
        costinfo: {
          amount2: "",
          feeitemList: [
            {
              amount: "",
              cnyamount: "",
              cnycurrency: "",
              currency: "",
              feecode: "",
              feeitem: "",
              piece: "",
              price: "",
            },
          ],
        },
        depwarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
        },
        deswarehouse: {
          address: "",
          area: "",
          city: "",
          province: "",
          tel: "",
          warehouse: "",
          deswarehouse: "",
        },
        message: {
          cneename: "",
          getgoodsaddress: "",
          getgoodsarea: "",
          getgoodscity: "",
          getgoodsname: "",
          getgoodsprovince: "",
          getgoodstel: "",
          goodstype: "",
          id: "",
          inputtime: "",
          inwarehoustime: "",
          ischangeaddress: true,
          isgetgoodstodoor: true,
          issendgoodstodoor: true,
          pod_country: "",
          pod_country_area: "",
          rece_address: "",
          rece_city: "",
          rece_country: "",
          rece_tel: "",
          shipper_name: "",
          shipper_tel: "",
        },
        schedule: {
          ata: "",
          atd: "",
          cls: "",
          eta: "",
          etd: "",
          pod: "",
          pol: "",
          route: "",
          shippingcompany: "",
          vessel: "",
          voyage: "",
        },
        settleinfo: {
          fkcode: "",
          fkstate: "",
          nopaid: "",
          paid: "",
          paymethod: "",
        },
        state: {
          dealdata: "",
          location: "",
        },
        waybilldetails: {
          abbr: "",
          createway: "",
          cusNos: "",
          inputtime: "",
          inwarehousetime: "",
          jobid: "",
          namec: "",
          nos: "",
          pod_country: "",
          product: "",
          remark: "",
          transportway: "",
          warehouse: "",
        },
      },
      routes: {},
      activeName: "second",
      reverse: false,

      guiji: false,
      fileName: "",
      fileUrl: "",
      preAllCbm: "",
      isActiveName: "first",
      transportNameMapping: {
        空运: '航空',
        海运: '船运',
        陆运: '陆运'
      }
    };
  },
  watch: {
     $route: function (newVal, oldValue) {
      //监听到路由变化重新加载数据
      this.routes.nos = this.$route.params.nos;
      this.getalldata();
    },
  },
  methods: {
    setType(key) {
      const options = {
        KP: '卡派',
        HK: '海卡',
        HP: '海派',
        WC: '整柜直送',
        FP: '空派',
        KK: '空卡',
        ZT: '自提',
        KDP: '快递派',
        KH: '卡航',
        TL: '铁路',
        empty: '-'
      }
      return options[key]
    },
    // 过机图片
    pictureUrl(item) {
      console.log("pictureUrl: ", item.pictureUrl);
      this.imgUrl = item.pictureUrl;
      this.dialogTableVisible = true;
    },
    downLoadLabel() {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${this.routes.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    changeAc(index) {
      this.acIndex = index;
    },
    beforeClose() {
      this.showPic = false;
      this.showBox = false;
      this.showDialog = false;
    },
    getBoxDetail(goodsList, row) {
      this.goodsList = goodsList.map((res) => {
        return Object.assign({}, res);
      });
      this.showGoodsList = true;
      console.log(goodsList);
    },
    toBoxTracking(id) {
      // console.log(id);
      this.axios
        .post(
          `/fbxTrail/findBoxTrail`,
          qs.stringify({
            orderNo: this.routes.nos,
            boxId: id,
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              console.log(2);
              this.boxDatailList = res.data.datas;
              this.showDialog = true;
              this.showBox = true;
            } else {
              this.$message("没有相关信息");
            }
          } else {
            this.$message("获取失败");
          }
        })
        .catch((res) => {});
    },
    getBoxInfo() {
      //   let id = "";
      //   this.activitieList.length &&
      //     this.activitieList.forEach((item) => {
      //       if (item.apptWarehouseOrderId) {
      //         id = item.apptWarehouseOrderId;
      //       }
      //     });
      //     console.log(id);
      //   if (!id) return;
      this.axios
        .post(
          `/fbxTrail/queryApptWarehouseOrderBoxs`,
          qs.stringify({
            orderNo: this.orderNo,
            apptWarehouseOrderId: "18955654000",
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.boxInfo = res.data.datas;
              //   this.showDialog = true
              //   this.showBox = true;
            } else {
              this.$message("没有相关箱号");
            }
          } else {
            this.$message("获取失败");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getPics(id) {
      this.axios
        .post(`/fbxTrail/findApptWarehouseOrderReceipt/${id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.datas.length) {
              this.urls = res.data.datas;
              this.showDialog = true;
              this.showPic = true;
            } else {
              this.$message("没有相关回执");
            }
          } else {
            this.$message("获取失败");
          }
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    handleClick(tab, event) {
      //tabs的点击方法
      // console.log(tab.paneName);
      if (tab.paneName === "third") {
        this.axios
          .get("/fbxTrail/findOrderTrailByOrderNo/" + this.routes.nos, {
            headers: { language: "CN" },
          })
          .then((response) => {
            if (response.data.code == 200) {
              if (response.data.datas.length) {
                this.activitieList = response.data.datas;
              } else {
                this.$message("没有相关轨迹");
              }
            } else {
              this.$message("获取失败");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    preViewPic(url) {
      uni.previewImage({
        urls: [url],
      });
    },
    // jack
    getSummaries(param) {
      //合计第一列不显示合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    comeback() {
      //返回上一页
      this.$router.push({ name: "MyOrderDetails" });
    },
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },

    getalldata() {
      let data = {
        jobtype: "FBX",
        language: "CN",
        nos: this.routes.nos,
        state: this.routes.state,
      };
      // console.log(data)

      this.axios
        .post("/busFbx/getFbxJobsHistoryWebSingleList", data)
        .then((response) => {
          // console.log(response.data.data);
          this.Alldata = response.data.data;
          // console.log(this.Alldata);
          this.Alldata = JSON.parse(JSON.stringify(this.Alldata));
          this.tableData_C1 = response.data.data.cargobefore;
          this.tableData_C2 = response.data.data.cargo;
          if (response.data.data.combincostinfo) {
            this.tableData1 =
              response.data.data.combincostinfo.combinCostinfoList; //数据列表
            this.twotableData = [
              {
                feeitem: "合计",
                amountBefore: response.data.data.combincostinfo.totalCostBefore,
                amount: response.data.data.combincostinfo.totalCost,
              },
              {
                feeitem: "折合人民币",
                amountBefore: response.data.data.combincostinfo.amountBefore,
                amount: response.data.data.combincostinfo.amount,
              },
            ];
            // if (response.data.data.combincostinfo.couponPrice) {
            //     this.twotableData = [
            //       {
            //         feeitem: "原价",
            //         amountBefore: response.data.data.combincostinfo.totalCostBefore,
            //       },
            //       {
            //         feeitem: '已优惠',
            //         amountBefore: response.data.data.combincostinfo.couponPrice
            //       },
            //       {
            //         feeitem: "合计",
            //         amountBefore: response.data.data.combincostinfo.amountBefore // 优惠折合后金额
            //       }
            //     ];
            //   } else {
            //     this.twotableData = [
            //       {
            //         feeitem: "合计",
            //         amountBefore: response.data.data.combincostinfo.totalCostBefore,
            //         amount: response.data.data.combincostinfo.totalCost,
            //       },
            //       {
            //         feeitem: "折合人民币",
            //         amountBefore: response.data.data.combincostinfo.amountBefore,
            //         amount: response.data.data.combincostinfo.amount,
            //       },
            //     ];
            //   }
          }
          if (response.data.data.fastOrderedOtherInfoDTO) {
            if (response.data.data.fastOrderedOtherInfoDTO.boxProInfoDTOS) {
              this.tableDataPro =
                response.data.data.fastOrderedOtherInfoDTO.boxProInfoDTOS;
            } else {
              this.tableDataPro = [];
            }
            this.preBoxNum =
              response.data.data.fastOrderedOtherInfoDTO.preBoxNum;
            this.preAllCbm =
              response.data.data.fastOrderedOtherInfoDTO.preAllCbm;
            this.preAllWeight =
              response.data.data.fastOrderedOtherInfoDTO.preAllWeight;
            if (response.data.data.fastOrderedOtherInfoDTO.orderAttachmentDTO) {
              this.fileName =
                response.data.data.fastOrderedOtherInfoDTO.orderAttachmentDTO.fileName;
              this.fileUrl =
                response.data.data.fastOrderedOtherInfoDTO.orderAttachmentDTO.fileUrl;
            } else {
              this.fileName = "";
              this.fileUrl = "";
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CargoTrackByNo() {},
  },
  created() {
    // this.routes = this.$route.query;
    // this.state = this.routes.state;

    // new
    console.log("this.$route.params", this.$route.params);
    this.routes = this.$route.params;
    this.state = this.routes.state;

    this.CargoTrackByNo();
    this.getalldata();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.view-image {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: block;
}
.jackTextAc {
  font-size: 18px;
  font-weight: 600;
  color: #FF4D01;
}

.jackText:hover {
  color: #FF4D01;
}
.jackText {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.jackText:hover {
  color: #FF4D01;
}
.jackContent {
  padding: 10px;
  .el-timeline-item__content {
    width: 500px;
  }
}
.jackRadius {
  /deep/.el-dialog {
    border-radius: 20px;
  }
}
.jackCard {
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin: 20px 0 20px 30px;
  background: #ffffff;
  position: relative;
  width: 95%;
  box-sizing: border-box;
}
.OrderDetails {
  // width: 100%;
  /* background: #FBFBFB; */
  border-radius: 5px;
}
.OrderDetails .comeback {
  width: 95%;
  display: flex;
  justify-content: flex-end;
  height: 28px;
  margin-left: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.OrderDetails .divbox {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  box-sizing: border-box;
  padding-right: 40px;
}
.OrderDetails h4 {
  /*height: 18px;*/
  padding-top: 18px;
  margin-left: 24px;
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: bold;
  color: #343434;
}
.OrderDetails .RequestInfo {
  margin-top: 22px;
}
.OrderDetails .Blurb {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
}
.OrderDetails .Information {
  padding-bottom: 22px;
}
.OrderDetails .Blurb .tablebox {
  width: 49%;
  background: #ffffff;
  padding-bottom: 20px !important;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails .Blurb .tablebox:nth-child(1) {
  margin-right: 2%;
}
.OrderDetails .divbox .RI_ul {
  display: flex;
}
.OrderDetails .divbox .RI_ul li {
  width: 31%;
  margin-left: 24px;
  margin-top: 20px;
}
.OrderDetails .divbox .RI_ul li:nth-child(1) {
  margin-left: 0;
}
.OrderDetails .divbox .RI_ul li:nth-child(2) {
  margin-left: 1%;
  margin-right: 1%;
}
.OrderDetails .divbox .RI_ul li p {
  margin-bottom: 19px;
  font-size: 14px;
  /* mar- */
}
.OrderDetails .divbox .RI_ul li p span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.OrderDetails .divbox .RI_ul li p span:nth-child(1) {
  width: 90px;
  margin-right: 27px;
  color: #9a9a9a;
  text-align: right;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(2) {
  width: 200px;
  height: 16px;
  color: #343434 !important;
  text-align: left;
}
.OrderDetails .Information .RI_ul li {
  margin-top: 0px;
}
/* element */
.OrderDetails .endtwotr {
  margin-top: -2px;
}
.OrderDetails .Information .el-timeline-item {
  padding-bottom: 30px;
}
.OrderDetails .Blurb .el-table td,
.el-table th {
  padding: 8px 0;
}
.OrderDetails .Information .el-table td,
.el-table th {
  padding: 7px 0;
}
.OrderDetails .el-tabs__item {
  font-size: 16px;
}
.OrderDetails .el-timeline-item__tail {
  position: absolute;
  left: 155px;
  top: 7px;
}
.OrderDetails .el-timeline-item__node--normal {
  left: 150px;
}
.OrderDetails .el-timeline-item__wrapper {
  width: 260px;
  padding-left: 175px;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: #333333;
}
.OrderDetails .el-timeline-item__timestamp.is-bottom {
  position: absolute;
  right: 295px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
}
.OrderDetails .el-tabs__nav-wrap::after {
  background: none;
}
.OrderDetails .el-table td,
.el-table th {
  text-align: center;
}
.OrderDetails .Blurb .el-table__header tr,
.OrderDetails .Blurb .el-table__header th {
  padding: 0;
  height: 38px;
  line-height: 38px;
}
.OrderDetails .Information .el-table__header tr,
.OrderDetails .Information .el-table__header th {
  padding: 0;
  height: 31px;
  line-height: 31px;
}
.OrderDetails .el-tabs__header {
  margin-left: 21px;
  padding-top: 5px;
  margin-bottom: 25px;
  font-size: 18px;
}
/* table 滚动条 */
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}

.tips-all {
  display: flex;
  align-items: center;
}

.downLondBtn {
  position: absolute;
  top: 19px;
  left: 340px;
}

.el-table {
  width: 96% !important;
}
.descSty{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaOrderDetails.vue